export enum PersistedRecordingDownloadStatus {
    Queued = "Queued",
    QueuedForRetry = "QueuedForRetry",
    QueuedForRetryByUser = "QueuedForRetryByUser",
    Scheduled = "Scheduled",
    Downloading = "Downloading",
    Converting = "Converting",
    Uploading = "Uploading",
    Completed = "Completed",
    Failed = "Failed",
}
